module.exports = __webpack_public_path__ + "img/sv105.4aaabe4d.svg";